import * as types from "../../mutation-types";

const mutations = {
    [types.SET_SM_CONTRACTS_PURCHASE_SALES]: (state, payload) => {
        state.sm_contracts_purchase_sales = payload;
    },
    [types.SET_SM_CONTRACTS_PURCHASE_SALE_TYPES]: (state, payload) => {
      state.sm_contracts_purchase_sale_types = payload;
    },
}

export default mutations;
